import * as React from 'react';
import * as Markdown from 'react-markdown';
import { faro } from '@grafana/faro-react';

interface CriticalErrorProps {
    message: string;
    onClose: () => void;
}

export const CriticalError = ({ message, onClose }: CriticalErrorProps) => {
    React.useEffect(() => {
        if (faro.api !== undefined && faro.api !== null)
            faro.api.pushEvent(message);
    }, [message]);

    return (
        <>
            <div className="modal-body">
                <div
                    className="text-center">
                    <p
                        style={{ fontSize: 100 + 'px' }}
                        className="text-center text-danger">
                        <i
                            className="fa fa-times-circle"
                            aria-hidden="true"></i>
                    </p>
                    <div className="text-center">
                        <Markdown>
                            {message}
                        </Markdown>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onClose}>Close</button>
            </div>
        </>
    );
}
